import React from 'react';
import { bool, arrayOf, shape } from 'prop-types';
import { Loader } from '@thd-olt-component-react/core-ui';
import { StoreCard } from '../store-card/store-card';

import './location-list.scss';

export const LocationList = ({ availabilityData, isLoading }) => {

  return (
    <div className="locations-list">
      {availabilityData?.length > 0 && (
        <div className="locations-wrapper" data-testid="locations-wrapper">
          {availabilityData.map((nearByStore) => (
            <StoreCard key={nearByStore.storeId} store={nearByStore} />
          ))}
        </div>
      )}
      {isLoading && (
        <div className="center" data-testid="location-loader">
          <Loader active />
        </div>
      )}
    </div>
  );
};

LocationList.propTypes = {
  availabilityData: arrayOf(shape({})).isRequired,
  isLoading: bool.isRequired
};
